<script setup lang="ts">
import { computed } from 'vue'
import { publicPhotos, type PublicPhotoId } from '../content/public-photos'
const props = defineProps<{ image: PublicPhotoId }>()
const photo = computed(() => publicPhotos[props.image])
</script>
<template><small class="photo-credit"><a :href="photo.source" target="_blank" rel="noopener noreferrer">{{ photo.author }}</a> · <a :href="photo.licenseUrl" target="_blank" rel="noopener noreferrer" :title="photo.changes">{{ photo.license }}</a><span class="sr-only">. {{ photo.changes }}</span></small></template>
